import { z } from 'zod';
export const MAX_FIXES_PER_TAG_PER_FLUSH = 20;
export const MAX_FIXES_PER_SITE_FLUSH = 500;
export const MAX_LAYERS_PER_OCCUPANCY_FLUSH = 64;
export const PositionFixSchema = z.object({
    serialNumber: z.string().min(1),
    x: z.number(),
    y: z.number(),
    z: z.number().optional(),
    layerId: z.number().int().optional(),
    /** Gateway receive time (ISO 8601 UTC). */
    lastSeenAt: z.string().datetime(),
    battery: z.number().optional(),
    sosActive: z.boolean().optional(),
});
export const PositionBatchMqttPayloadSchema = z.object({
    pk: z.string().min(1),
    gatewaySerial: z.string().min(1),
    flushedAt: z.string().datetime(),
    fixes: z.array(PositionFixSchema).min(1).max(MAX_FIXES_PER_SITE_FLUSH),
});
export const TagStatusUpdateSchema = z.object({
    serialNumber: z.string().min(1),
    deviceCategory: z.literal('location-tag'),
    online: z.boolean().optional(),
    sosActive: z.boolean().optional(),
    battery: z.number().optional(),
    firmwareVersion: z.string().optional(),
    hardwareVersion: z.string().optional(),
    x: z.number().optional(),
    y: z.number().optional(),
    z: z.number().optional(),
    layerId: z.number().int().optional(),
    /** Gateway receive time (ISO 8601 UTC). */
    lastSeenAt: z.string().datetime(),
});
export const AnchorStatusUpdateSchema = z.object({
    serialNumber: z.string().min(1),
    deviceCategory: z.literal('location-anchor'),
    online: z.boolean().optional(),
    firmwareVersion: z.string().optional(),
    hardwareVersion: z.string().optional(),
    x: z.number().optional(),
    y: z.number().optional(),
    z: z.number().optional(),
    layerId: z.number().int().optional(),
    /** Gateway receive time (ISO 8601 UTC). */
    lastSeenAt: z.string().datetime(),
});
export const StatusBatchMqttPayloadSchema = z
    .object({
    pk: z.string().min(1),
    gatewaySerial: z.string().min(1),
    flushedAt: z.string().datetime(),
    tagUpdates: z.array(TagStatusUpdateSchema).max(200),
    anchorUpdates: z.array(AnchorStatusUpdateSchema).max(200),
})
    .refine((v) => v.tagUpdates.length + v.anchorUpdates.length > 0, {
    message: 'At least one status update required',
});
export const LayerOccupancyUpdateSchema = z.object({
    scopeType: z.literal('layer'),
    scopeId: z.string().min(1),
    tagCount: z.number().int().nonnegative(),
    locationDeviceIds: z.array(z.string().min(1)),
    /** Gateway receive time (ISO 8601 UTC). */
    lastSeenAt: z.string().datetime(),
    complete: z.boolean(),
    sourceMessages: z.array(z.string().min(1)).min(1),
    recordCount: z.number().int().nonnegative().optional(),
    totalCount: z.number().int().nonnegative().optional(),
});
export const OccupancyBatchMqttPayloadSchema = z.object({
    pk: z.string().min(1),
    gatewaySerial: z.string().min(1).nullable(),
    flushedAt: z.string().datetime(),
    layers: z.array(LayerOccupancyUpdateSchema).min(1).max(MAX_LAYERS_PER_OCCUPANCY_FLUSH),
});
export function sortPositionFixes(fixes) {
    return [...fixes].sort((a, b) => {
        const serialCmp = a.serialNumber.localeCompare(b.serialNumber);
        if (serialCmp !== 0) {
            return serialCmp;
        }
        return a.lastSeenAt.localeCompare(b.lastSeenAt);
    });
}
//# sourceMappingURL=location-telemetry-batch.schema.js.map